import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { billingKeys } from '../queries/keys';
import { billingPaths } from '../queries/paths';

// TSS vite/03 — rubros de costo (admin-billing-catalog.md · Capa 5). `amount` = COP
// (DECIMAL). `quantitative` marca si escala por cantidad en la composición.
// Permisos: billing:read (lectura) / billing:write (mutación).

function clean(filters = {}) {
    const out = {};
    for (const k of ['limit', 'offset', 'sort', 'status', 'quantitative', 'magnitude', 'q']) {
        const v = filters[k];
        if (v !== '' && v != null) out[k] = v;
    }
    return out;
}

export function useCostsList(filters) {
    const params = clean(filters);
    return useQuery({
        queryKey: billingKeys.costs(params),
        queryFn:  ({ signal }) => api.get(billingPaths.costs(), { params, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}

export function useCreateCost() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(billingPaths.costs(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function useUpdateCost(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.patch(billingPaths.cost(id), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function useDeleteCost() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(billingPaths.cost(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}
